import { CheckCircle } from '@mui/icons-material';
import { DialogActions, Typography } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { approveExpressFactoringRequest } from '../../../../../../../../../../../../../lib/api/express';
import CustomButton from '../../../../../../../../../../../../../lib/designSystem/Button';
import CenteredCircularProgress from '../../../../../../../../../../../../../lib/designSystem/CircularProgress';
import { AuthState } from '../../../../../../../../../../../../../services/redux/authSlice';
import InforPreview from '../../../../../../../../../common/InforPreview';
import SimulationDoneFrozen from '../../../../../../../../../common/SimulationDoneFrozen';

const ShoppingCartFactoringInReview = (props: any) => {
  const {
    setOpenShoppingcart,
    setSelectedRequest,
    selectedRequest,
    handleCancelQuote,
    setUp,
  } = props;
  const [loading, setLoading] = React.useState(false);

  const infoDiv = (
    <InforPreview
      requestType="factoring"
      type="Sent"
      status="En revisión"
      selectedRequest={selectedRequest}
    />
  );

  const dispatch = useDispatch();
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);

  const handleAccept = async () => {
    setLoading(true);
    try {
      const companyRecieverId = user?.clientId;
      if (!companyRecieverId) return setLoading(false);
      await approveExpressFactoringRequest(
        dispatch,
        companyRecieverId,
        selectedRequest.quoteActive.id,
      );
    } catch (error) {
      alert('Error al aceptar la solicitud');
      console.log(error);
    }
    setOpenShoppingcart(false);
    await setUp();
    setLoading(false);
  };
  if (loading) return <CenteredCircularProgress type="dialog" />;

  return (
    <div>
      <div>
        <SimulationDoneFrozen
          infoDiv={infoDiv}
          selectedRequest={selectedRequest}
          setSelectedRequest={setSelectedRequest}
        />
        <DialogActions>
          <CustomButton
            onClick={() => setOpenShoppingcart(false)}
            color="secondary"
          >
            Salir
          </CustomButton>
          <CustomButton
            color="error"
            onClick={() => handleCancelQuote()}
            disabled={selectedRequest.alreadyApproveByCreator}
          >
            Rechazar
          </CustomButton>
          <CustomButton
            disabled={selectedRequest.alreadyApproveByCreator}
            onClick={() => handleAccept()}
            color="primary"
          >
            Aceptar
          </CustomButton>
        </DialogActions>
        {selectedRequest.alreadyApproveByCreator && (
          <div
            style={{
              display: 'flex',
              alignItems: 'top',
              paddingTop: 10,
            }}
          >
            <CheckCircle style={{ color: 'green', marginRight: '5px' }} />
            <Typography>
              La solicitud ya fue aprobada por ti, ahora debes esperar a que la
              empresa la revise.
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
};

export default ShoppingCartFactoringInReview;
